<template>
	<div>
		<div class="relative block h-full mx-auto border rounded-lg shadow-md max-w-300 min-w-48">
			<RouterLink
				:to="dealUrl"
				:disabled="preventRoute"
				:event="!preventRoute ? 'click' : ''"
			>
				<div class="relative h-48">
					<WwImage
						:src="deal.image"
						classes="rounded-t-md w-full"
						object-cover
						:alt="deal.title"
						:fallback-image="DEFAULT_WW_GRAY_LOGO"
						:width="375"
						:height="250"
						image-type="deal"
					/>
				</div>
				<div class="px-2">
					<h4 class="my-2 text-lg text-black min-h-14 max-h-16">
						<span class="h-full font-semibold leading-tight line-clamp-3">
							{{ deal.title }}
						</span>
					</h4>
					<div class="flex justify-between w-full mb-2 text-sm uppercase text-gray-3">
						<div
							class="truncate"
							tabindex="0"
						>
							{{ deal.category }}
						</div>
						<div
							v-if="indication"
							tabindex="0"
						>
							{{ indication }}
						</div>
						<div
							class="flex items-center align-center"
							tabindex="0"
						>
							<img
								:src="heartIcon"
								class="w-3 h-3 mr-1 opacity-30"
								alt="Heart"
							>
							<div class="text-gray-3">
								{{ deal.claim_count }}
							</div>
						</div>
					</div>
				</div>
			</RouterLink>
			<RouterLink
				v-if="deal.business_url"
				:to="deal.business_url"
				class="block px-2 text-sm font-bold text-black truncate"
				@click.prevent
			>
				by {{ deal.business_name }}
			</RouterLink>
			<span
				v-if="isClaimed"
				class="absolute top-0 w-full text-center text-white bg-green-500 rounded-t-lg opacity-90"
				tabindex="0"
			>
				claimed
			</span>
		</div>
	</div>
</template>

<script>
import { INDICATION_TYPES } from '@/constants/business/index.js'
import { DEFAULT_WW_GRAY_LOGO } from '@/constants/search/defaultImage.js'
import buildImageUrl from '@/utils/builders/buildImageUrl'
import requireIcon from '@/utils/requireIcon'
const { MED_AND_REC } = INDICATION_TYPES

export default {
	components: {
		WwImage: () => import('@/components/multiUse/WwImage')
	},
	props: {
		deal: {
			type: Object,
			required: true
		},
		preventRoute: {
			type: Boolean,
			default: false
		},
		isClaimed: {
			type: Boolean,
			default: false
		},
		compact: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			DEFAULT_WW_GRAY_LOGO
		}
	},
	computed: {
		indication() {
			return this.deal.indication === MED_AND_REC
				? false
				: this.deal.indication
		},
		heartIcon() {
			return requireIcon('heart-full.svg')
		},
		dealUrl() {
			return this.deal.business_url
				? `${this.deal.business_url}/deals/view/${this.deal.deal_id}`
				: `deals/view/${this.deal.deal_id}`
		},
		isMobile() {
			return this.mediaMatch === 'sm' || this.mediaMatch === 'xs'
		},
		mediaMatch() {
			return this.$store.state.mediaMatch
		}
	},
	methods: {
		useDefaultMainImage(event) {
			event.target.src = this.defaultMainImage
		},
		hasData(data, type) {
			// eslint-disable-next-line valid-typeof
			return typeof (data) === type && data !== ''
		},
		requireIcon,
		buildImageUrl
	}
}
</script>

<style lang="scss" scoped>
.max-w-300 {
	max-width: 300px;
}
.mobile-card-height {
	height: 19rem;
}
.min-w-48 {
	min-width: 12rem;
}
</style>
